<script>
export default {
  inheritAttrs: false,
  model: {
    prop: 'modelValue',
    event: 'change',
  },
  props: {
    value: { type: [String, Number, Boolean], default: null },
    modelValue: { type: [String, Number, Boolean], default: null },
  },
  computed: {
    localModel: {
      get() {
        return this.modelValue
      },
      set() {
        this.$emit('change', this.value)
      },
    },
  },
}
</script>

<template>
  <div class="flex items-center">
    <input v-model="localModel" type="radio" v-bind="$attrs" :value="value" />
    <label class="label m-0 ml-2" :for="$attrs.id">
      <slot />
    </label>
  </div>
</template>
